<template>
  <div id="pbn-filters">
    <filters-modal :filter-data="userFiltersData"></filters-modal>
    <results-modal :result="resultFiltersData"></results-modal>
    <div v-if="f.userData && f.userData.filters" class="col-lg-12">
      <div class="col-lg-3 col-md-3">
        <div>
          <v-select
            placeholder="Saved Filters"
            label="name"
            :options="filtersOptions"
            @change="loadFilter"
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3" v-if="filterSelected">
        <a v-if="editView === false" @click="editView = true" v-tooltip="'Edit the selected filter'">
          <i class="fa fa-edit lg"></i>
        </a>
        <div v-if="editView">
          <input placeholder="Selected filter name" type="text" v-model="newFilterName"  id="active-filter"
            class="col-lg-8 form-control">
        </div>
      </div>
      <div class="col-lg-6 col-md-6" v-if="editView">
        <button
          class="btn btn-sm btn-danger m-r-xs"
          @click="deleteFilter"
        ><i class="fa fa-trash"></i> Delete Filter</button>
        <button
          class="btn btn-sm btn-success m-r-xs"
          @click="updateFilter"
        ><i class="fa fa-filter"></i> Update Filter</button>
        <a v-tooltip="'Close filter edit'" @click="editView = false">
          <i class="fa fa-multiply fa-lg"></i>
        </a>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div><input placeholder="URL" type="text" v-model="filters['url']" name="url" id="id-url" ref="url"
                    class="col-lg-8 form-control" @keydown.enter="search"></div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.clients.length > 1 || user.roles.length > 1">
        <div>
          <v-select
            placeholder="Client"
            v-if="this.f.clients && this.f.clients.length"
            :options="f.clients"
            label="name"
            index="id"
            multiple="multiple"
            v-model="filters['clients']"
          >
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
        <div>
          <v-select
            v-model="filters['groups']"
            :options="this.f.groups"
            index="id" label="fullName"
            placeholder="Group"
            multiple
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Order" :options="this.f.orders" multiple="multiple" label="fullName" index="id"
                    v-model="filters.orders">
          </v-select>
        </div>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Status" multiple :options="statuses" label="label" index="id" v-model="filters.status">
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Type" multiple :options="types" v-model="filters['type']" index="index">
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Category" multiple :options="this.f.categories" v-model="filters.categories">
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select :options="tlds" v-model="filters['tlds']" index="tld" label="tld" @search="fetchTlds" multiple placeholder="Tld">
          </v-select>
        </div>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
        <div>
          <v-select
            v-model="filters.registrars"
            :options="this.f.registrars"
            placeholder="Registrar"
            index="id"
            label="name"
            multiple
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.client === null">
        <div>
          <v-select placeholder="Hosting" multiple :options="f.hosts" v-model="filters['hosting']" index="id" label="name">
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.client === null">
        <div>
          <v-select
            placeholder="Hosting Type"
            :options="[{index: 'CUSTOM_HOST', label: 'Digital Ocean'}, {index: 'SHARED_HOSTING', label: 'Priority Prospect'}]"
            v-model="filters['hostingType']" index="index">
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Domain Hold"
            :options="[{index: 'unknown', label: 'Not Set'}, {index: 'hold', label: 'Hold'}, {index: 'letExpire', label: 'Let Expire'}]"
            v-model="filters['domainHold']"
          ></v-select>
        </div>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Links to"
            multiple
            :options="['No Own Links', 'No Money Links'].concat(this.f.linkTags)"
            v-model="filters['linkTags']"
          >
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Posts:</div>
          <input type="number" v-model="filters.stats['postsFrom']" min="0" name="" id="iPostsFrom" placeholder="from"
                 class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom" @keydown.enter="search">
          <input type="number" v-model="filters.stats['postsTo']" min="0" name="" id="iPostsTo" placeholder="to"
                 class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right" ref="postsTo"
                 @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Last Post:</div>
          <input type="date" v-model="filters['lastPostAfter']" min="0" name="" placeholder="after"
                 class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
          <input type="date" v-model="filters['lastPostBefore']" min="0" name="" placeholder="before"
                 class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input " @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Languages"
            multiple
            :options="languages"
            label="label"
            index="index"
            v-model="filters['language']"
          >
          </v-select>
        </div>
      </div>
    </div>
    <div class="search col-md-12 col-lg-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Tags"
            multiple
            :options="tagOptions"
            v-model="filters['tag']"
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Health"
            :options="[{index: 'true', label: 'Healthy'}, {index: 'false', label: 'QA Failing'}]"
            v-model="filters['healthy']"
            index="index"
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Issues"
            multiple
            :options="this.issues"
            v-model="filters['issues']"
            index="value"
          ></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Limit" :options="[250,1000,2500]" v-model="filters['limit']">
          </v-select>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 m-t-sm m-b-sm">
      <a class="btn" data-toggle="collapse" href="#collapseStats" role="button" aria-expanded="false"
         aria-controls="collapseStats">
        Stat filters
        <i class="fa fa-chevron-down btn-sm expand-show"></i>
        <i class="fa fa-chevron-up btn-sm expand-hide"></i>
      </a>
      <div class="search collapse" id="collapseStats">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Maj TF:</div>
              <input type="number" min="0" name="maj-tf-from" v-model.number="filters.stats['majTfFrom']" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
              <input type="number" min="0" name="maj-tf-to" v-model.number="filters.stats['majTfTo']" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input " @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Maj RD:</div>
              <input type="number" v-model.number="filters.stats['majRdFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['majRdTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Ahr DR:</div>
              <input type="number" v-model.number="filters.stats['AHDrFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['AHDrTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input pull-right" ref="rdTo"
                     @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Ahr RD:</div>
              <input type="number" v-model.number="filters.stats['AHRdFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['AHRdTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <!-- 2nd col-->
        <div class="col-lg-3 col-md-3 m-t-sm m-b-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Moz DA:</div>
              <input type="number" v-model.number="filters.stats['mozDaFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['mozDaTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm m-b-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Sem KW:</div>
              <input type="number" v-model.number="filters.stats['semKwFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['semKwTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input pull-right" ref="daTo"
                     @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm m-b-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Traffic:</div>
              <input type="number" v-model.number="filters.stats['semTrafficFrom']" min="0" name="" placeholder="from"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="filters.stats['semTrafficTo']" min="0" name="" placeholder="to"
                     class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm m-b-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Grade:</div>
              <select v-model.number="filters.stats['gradeFrom']" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input">
                <option value="">&gt;&gt;&gt;</option>
                <option value="0">Bad</option>
                <option value="1">Poor</option>
                <option value="2">Medium</option>
                <option value="3">Good</option>
              </select>
              <select v-model.number="filters.stats['gradeTo']" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input">
                <option value="">&gt;&gt;&gt;</option>
                <option value="0">Bad</option>
                <option value="1">Poor</option>
                <option value="2">Medium</option>
                <option value="3">Good</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
            <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-search"></i> Search</button>
            <button class="btn btn-sm btn-success" @click="search($event, 'csv')"><i class="fa fa-download"></i> CSV
            </button>
            <button class="btn btn-sm btn-success" @click="getLinkReport" v-if="user.admin"><i
              class="fa fa-download"></i> Link Report
            </button>
            <button class="btn btn-sm btn-success" @click="getMoneyLinkReport" v-if="user.admin"><i
              class="fa fa-euro"></i> Money Link Report
            </button>
            <span class="pull-right">
              <button
                class="btn btn-sm btn-primary pull-right m-l-xs"
                @click="saveResultsModal"
                v-if="user.admin && user.username === 'rok'"
              ><i class="fa fa-plus"></i> Create New Result Template</button>
              <button
                class="btn btn-sm btn-primary pull-right m-l-xs"
                @click="saveFiltersModal"
              ><i class="fa fa-plus"></i> Create New Filter</button>
              <button
                class="btn btn-sm btn-danger pull-right"
                v-if="Object.keys(this.filters).length > 1"
                @click="filters = {stats: {}}"
              ><i class="fa fa-remove"></i> Reset Filters</button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 m-t-md">
        Showing <b>{{ meta.count }}</b> of <b>{{ meta.resultCount }}</b> results
        <i class="fa fa-info-circle text-primary" v-tooltip="'Change the limit to show more results'" v-if="meta.count < meta.resultCount"></i>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Browser, Query } from '../../../mixins/helperMixin'
import { PBNS_SET, APPLIED_FILTER_SET } from '../../../store/mutation-types'
import { mapGetters } from 'vuex'
import FiltersModal from './Build/Filters/FiltersModal'
import ResultsModal from './Build/Filters/ResultsModal'

export default {
  components: {
    FiltersModal,
    ResultsModal
  },
  data () {
    return {
      tlds: [],
      issues: [
        { label: 'No Logins', value: 'no-logins' },
        { label: 'Expiring soon', value: 'expiring-soon' },
        { label: 'Expired', value: 'expired' },
        { label: 'No Expiry Date', value: 'no-expiry' },
        { label: 'Parked', value: 'parked' },
        { label: 'Dns', value: 'dns' },
        { label: 'Status', value: 'status' },
        { label: 'SSL', value: 'ssl' },
        { label: 'No Access', value: 'no-access' },
        { label: 'Has Access', value: 'has-access' },
        { label: 'No SSO', value: 'no-sso' },
        { label: 'SSO', value: 'sso' },
        { label: 'PP IP Doesn\'t match', value: 'pp-ip-doesnt-match' },
        { label: 'PP IP Matches', value: 'pp-ip-matches' }
      ],
      statuses: [
        {label: 'Unknown', id: 'unknown'},
        {label: 'Not built', id: 'not-built'},
        {label: 'Building', id: 'building'},
        {label: 'Built', id: 'built'},
        {label: 'Waiting Deploy', id: 'waiting-deploy'},
        {label: 'Waiting Deploy Client', id: 'waiting-deploy-client'},
        {label: 'Disabled', id: 'disabled'}
      ],
      filters: {
        stats: {}
      },
      stats: {},
      multiFilters: {
        stats: {}
      },
      categories: [],
      tags: [],
      clients: [],
      orders: [],
      meta: {
        count: 0,
        resultCount: 0,
        limit: 0,
        offset: 0
      },
      userFiltersData: {},
      resultFiltersData: {
        'type': 'pbn'
      },
      triggerSearch: true,
      forceArrayValue: [
        'clients', 'groups', 'orders', 'issues', 'language', 'linkTags'
      ],
      filterSelected: false,
      selectedFilter: {},
      selectedFilterObj: {},
      newFilterName: '',
      editView: false
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      sites: 'getPbns',
      f: 'getFilters',
      user: 'getUser',
      languages: 'getLanguages',
      // types: 'getPbnTypes',
      appliedFilters: 'getAppliedFilters',
      types: 'getPbnTypes'
    }),
    tagOptions () {
      // added slicing here since tags have the first 3 prop to be "" - null - "?".
      // maybe we should delete those
      return this.f && this.f.tags ? this.f.tags.slice(3) : []
    },
    filtersOptions () {
      return this.f.userData.filters
    }
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    if (!this.languages.length) {
      this.$store.dispatch('loadLanguages')
    }
    if (Object.keys(this.appliedFilters).length) {
      this.filters = {...this.appliedFilters}
    }
    if (!this.types.length) {
      this.$store.dispatch('fetchPbnTypes')
    }
  },
  methods: {
    loadFilter (filter) {
      if (filter === null) {
        this.filterSelected = false
        this.editView = false
      } else {
        this.newFilterName = filter.name
        this.applyFilter(filter)
      }
    },
    applyFilter (filter) {
      if (!filter || !filter.filters) {
        this.filterSelected = false
        return
      }

      this.filterSelected = false
      this.selectedFilterObj = filter
      this.selectedFilter = filter.filters

      this.filters = { stats: {} }
      for (const f in this.selectedFilter) {
        if (this.forceArrayValue.includes(f) && typeof filter.filters[f] !== 'object') {
          this.filters[f] = [filter.filters[f]]
        } else {
          this.filters[f] = filter.filters[f]
        }
      }

      this.filterSelected = true
      this.search()
    },
    removeEmptyVals (filterObj) {
      let resultObj = {}
      resultObj = Object.fromEntries(Object.entries(filterObj).filter(([k, v]) => (v !== null && v !== undefined) && ((typeof v === 'number') || (v.length > 0))))

      if (Object.keys(filterObj).includes('stats')) {
        let stats = Object.fromEntries(Object.entries(filterObj.stats).filter(([k, v]) => typeof v === 'number' || v.length > 0))
        if (Object.values(stats).length) {
          resultObj.stats = stats
        }
      }

      return resultObj
    },
    search (e, type = null) {
      axios.get('/pbn/list?' + this.buildQuery(this.filters), {
        headers: {
          'Accept': type === 'csv' ? 'text/csv' : 'application/json'
        }
      }).then(r => {
        if (type === 'csv') {
          Browser.methods.downloadFile('Pbn-list.csv', r.data.data)
        } else {
          this.$store.commit(PBNS_SET, r.data.data)
          this.$store.commit(APPLIED_FILTER_SET, this.filters)
          this.meta = r.data.meta
        }
      }).catch(e => {
        this.$toastr.error(e, 'Whoopsy Daisy')
      })
    },
    getLinkReport () {
      let query = this.buildQuery(this.filters)
      if (!this.filters['linkTags']) {
        this.$toastr.warning('Please select Link Tags for report (Links to)', 'No Link Tags')
        return
      }
      axios.get('/pbn/content/links/report?' + query, {
        headers: {
          'Accept': 'text/csv'
        }
      }).then(r => {
        Browser.methods.downloadFile('Link-report.csv', r.data.data)
      }).catch(e => {
        this.$toastr.error(e, 'Whoopsy Daisy')
      })
    },
    getMoneyLinkReport () {
      let query = this.buildQuery(this.filters)
      // if (!this.filters['clients']) {
      //   this.$toastr.warning('Please select exactly 1 client for this report', 'Wrong Client Count')
      //   return
      // }
      axios.get('/pbn/report/money-links?' + query, {
        headers: {
          'Accept': 'text/csv'
        }
      }).then(r => {
        Browser.methods.downloadFile('Money-Link-report.csv', r.data.data)
      }).catch(e => {
        this.$toastr.error(e, 'Whoopsy Daisy')
      })
    },
    buildQueryBah () {
      let filters = {}
      Object.entries(this.multiFilters).forEach((data) => {
        filters[data[0]] = data[1].map(c => c.id)
      })

      let query = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&')
      query += '&' + Object.keys(this.filters).map(key => `${key}=${this.filters[key]}`).join('&')
      query += '&' + Object.keys(this.stats).map(key => `stats[${key}]=${this.stats[key]}`).join('&')
      return query
    },
    // resetFilters () {},
    fetchTlds (search, loading) {
      if (search.length < 3) {
        return
      }
      // loading(true)
      axios.get('/tlds?tld=' + search).then(r => {
        this.tlds = r.data.data
      }).catch(e => {
      })
    },
    saveFiltersModal () {
      $('#user-filters-modal').modal('show')
      this.userFiltersData = {
        filters: this.filters,
        name: null,
        path: 'pbn'
      }
    },
    saveResultsModal () {
      $('#result-filters-modal').modal('show')
      this.resultFilterData = {
        'type': 'pbn'
      }
    },
    async updateFilter () {
      try {
        let data = {
          id: this.selectedFilterObj.id,
          filters: this.removeEmptyVals(this.filters),
          name: this.newFilterName
        }
        await this.$store.dispatch('patchUserFilter', data)
        await this.$store.dispatch('loadFilters')
        this.$toastr.success('Filter edited successfully')
        this.editView = false
      } catch (err) {
        this.$toastr.error('Unable to edit the filter')
      }
    },
    async deleteFilter () {
      if (confirm(`Are you sure you want to delete ${this.selectedFilterObj.name}?`)) {
        try {
          await this.$store.dispatch('deleteUserFilter', this.selectedFilterObj)
          this.$toastr.success(`Filter ${this.selectedFilterObj.name} deleted`)
          await this.$store.dispatch('loadFilters')
          this.filters = { stats: {} }
          this.filterSelected = false
          this.editView = false
        } catch (e) {
          this.$toastr.error('Unable to delete filter')
        }
      }
    }
  }
}
</script>
<style scoped>
.green-left-border {
  border-left: 5px solid #18a689;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Filters.vue